// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NewMessagesDivider{align-items:center;box-sizing:border-box;color:#f47321;display:flex;margin-top:-8px}.NewMessagesDivider__Rule{background:#f47321;border:none;flex-grow:1;height:1px;margin:0}.NewMessagesDivider__Text{margin-left:7px}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
